const styles = {
    uploadContainer: {
        padding: 15,
    },
    dropZone: {
        border: "1px solid #d0cece",
        borderStyle: "dashed",
        borderRadius: 30,
        padding: 15,
    },
    dropArea: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
        height: 316,
    },
    uploadIcon: {
        margin: 40,
    },
    uploadTitle: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around",
        height: 80,
    },
    greyColor: {
        color: "#babcc3",
        fontSize: "small",
        textAlign: "center",
    },
    dropInput: {
        position: 'relative',
        height: '40px',
        marginBottom: '15px',
    },
    browseButton: {
        padding: "10px 20px",
        cursor: "pointer",
        borderRadius: "25px",
        borderColor: "#60bec9",
        color: "#60bec9",
    },
    limitError: {
        color: "red",
        fontSize: 13,
        fontWeight: 400,
        textAlign: "center",
    },
    filesContainer: {
        borderLeft: "1px solid #dfdede",
        padding: 15,
    },
    fileContainer: {
        justifyContent: "space-between",
        display: "flex",
        alignItems: "flex-start",
        backgroundColor: "#e5e5e5",
        padding: 10,
        borderRadius: 10,
        margin: "15px 0px",
    },
    fileIcon: {
        padding: "10px 5px",
    },
    fileDetails: {
        width: "100%",
        margin: "6px 15px",
    },
    fileName: {
        fontSize: 13,
        fontWeight: 400,
    },
    fileSize: {
        color: "#babdc3",
        fontSize: 12,
        display: "flex",
        alignItems: "center"
    },
    fileStatus: {
        alignItems: "center",
        display: "flex",
        color: '#a9acac',
        marginBottom: 0,
        marginLeft: -6
    },
    deleteIcon: {
        cursor: "pointer",
    },
    backArrow: {
        width: '24px',
        height: '24px',
        color: ' #543379',
        marginRight: '5px',
    },
    progInfoSection: {
        padding: 20,
        background: "#ffffff",
        marginTop: 20,
    },
    smallFont: {
        fontSize: "small",
        textAlign: "center",
    }
};

export default styles;